import { render } from "./UserAccountLoginView.vue?vue&type=template&id=206d8426&scoped=true"
import script from "./UserAccountLoginView.vue?vue&type=script&lang=js"
export * from "./UserAccountLoginView.vue?vue&type=script&lang=js"

import "./UserAccountLoginView.vue?vue&type=style&index=0&id=206d8426&scoped=true&lang=css"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206d8426"]])

export default __exports__